import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
import { Lock } from 'lucide-react';
export function OfferBlock() {
  return <section id="offer-block" className="py-24 px-4 sm:px-6 lg:px-8 bg-brand-dark" data-id="element-82">
      <div className="max-w-3xl mx-auto" data-id="element-83">
        <FadeIn data-id="element-84">
          <p className="text-lg text-brand-offwhite/80 leading-relaxed mb-10 text-center" data-id="element-85">
            Recuperar tu paz mental y evitar años de terapia innecesaria
            normalmente costaría cientos de dólares. Hoy puedes acceder a la
            hoja de ruta completa por el precio de una cena.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-86">
          <div className="bg-[#1a1a1a] border border-brand-amber/20 rounded-2xl p-8 sm:p-10 max-w-xl mx-auto" data-id="element-87">
            <div className="flex flex-col items-center gap-6" data-id="element-88">
              <img src="https://cdn.magicpatterns.com/uploads/2RevpZ7SHfaLmJ8rigFk3V/IMG_8530.png" alt="Acceso en todos tus dispositivos" className="w-64 sm:w-72 drop-shadow-xl rounded-lg" data-id="element-89" />

              <div className="flex items-center gap-4" data-id="element-90">
                <span className="text-xl text-brand-offwhite/40 line-through decoration-red-500/50" data-id="element-91">
                  $27 USD
                </span>
                <span className="text-5xl font-serif font-bold text-brand-amber" data-id="element-92">
                  $6.36 USD
                </span>
              </div>

              <CTAButton className="w-full text-lg py-5 px-10" href="https://www.seresconsciente.com/cart/46459137228971:1" data-id="element-93" />

              <div className="flex flex-col items-center gap-1 text-sm text-brand-offwhite/50 text-center" data-id="element-94">
                <div className="flex items-center gap-2" data-id="element-95">
                  <Lock className="w-4 h-4" data-id="element-96" />
                  <span data-id="element-97">Pago seguro y descarga instantánea.</span>
                </div>
                <span data-id="element-98">El cargo en tu tarjeta aparecerá de forma discreta.</span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}